import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../context/useUser";

export default function AdminRoute() {
  const { user } = useUser();

  if (!user?.token) {
    return <Navigate to="/signin" replace />;
  }

  if (!user?.is_admin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}